export function drawer() {

  // headerScroll();
  document.addEventListener('DOMContentLoaded', function () {
    const hamburgers = document.querySelectorAll('.js-hamburger');
    const drawer = document.querySelector('.js-drawer');

    hamburgers.forEach(function (hamburger) {
      hamburger.addEventListener('click', function () {
        const isOpen = this.classList.contains('is-open');

        if (isOpen) {
          this.classList.remove('is-open');
          closeDrawer();
        } else {
          this.classList.add('is-open');
          openDrawer();
        }
      });
    });

    document.querySelectorAll('.js-drawer a[href], .p-header__list a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function () {
        closeDrawer();
        hamburgers.forEach(function (hamburger) {
          hamburger.classList.remove('is-open');
        });
      });
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 760px)').matches) {
        closeDrawer();
        hamburgers.forEach(function (hamburger) {
          hamburger.classList.remove('is-open');
        });
      }
    });

    window.addEventListener('beforeunload', function () {
      closeDrawer();
    });

    function openDrawer() {
      drawer.classList.add('is-open');
      document.body.classList.add('body-no-scroll');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('body-no-scroll');
    }
  });
}
